import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import AddButton from "../../../assets/icons/Card Add button.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { DownOutlined } from "@ant-design/icons";
import { Table, Space, Dropdown, Menu } from "antd";
import delete1 from "../../../assets/images/delete.svg";
import pdfIcon from "../../../assets/images/PdfIcon.svg";
import "../../../assets/styles/local/Maintenance.css";
import styles from "../AddGroupPopup.module.css";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import {
  ChangesPOStatus,
  DeletePOAsset,
  FetchPurchasingAssetList,
} from "../../../redux/actions/action";
import { FETCH_PURCHASING_ASSET_LIST } from "../../../redux/constants/type";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";
const Purchasing = ({ assetsData }) => {
  const [tableData, setTableData] = useState([]);
  const [hoveredRowKey, setHoveredRowKey] = useState(null);
  const dispatch = useDispatch();
  const assetId = window.localStorage.getItem("assetId");

  useEffect(() => {
    if (assetId) {
      dispatch(FetchPurchasingAssetList(assetId));
    }
  }, [dispatch, assetId]);

  const deleteItem = (assetPurchasingOrderid) => {
    dispatch(DeletePOAsset(assetPurchasingOrderid));
  };
  const handleStatusUpdate = (assetPurchasingOrderid, statusid) => {
    dispatch(ChangesPOStatus(assetPurchasingOrderid, statusid));
  };
  const FetchPurchasingAssetData = useSelector((state) => {
    return state.user.fetchPurchasingAssetList;
  });
  const DeletePoAssetData = useSelector((state) => {
    return state.user.deletePo;
  });
  const ChangePoStatusData = useSelector((state) => {
    return state.user.changePoStatus;
  });

  useEffect(() => {
    if (DeletePoAssetData?.data && DeletePoAssetData?.status) {
      if (assetId) {
        dispatch(FetchPurchasingAssetList(assetId));
      }
    }
  }, [DeletePoAssetData?.data, DeletePoAssetData?.status, assetId, dispatch]);

  useEffect(() => {
    if (ChangePoStatusData?.data && ChangePoStatusData?.status) {
      if (assetId) {
        dispatch(FetchPurchasingAssetList(assetId));
      }
    }
  }, [ChangePoStatusData?.data, ChangePoStatusData?.status, assetId, dispatch]);

  useEffect(() => {
    if (FetchPurchasingAssetData?.data && FetchPurchasingAssetData?.status) {
      setTableData(FetchPurchasingAssetData.data);

      dispatch({
        type: FETCH_PURCHASING_ASSET_LIST,
        data: [],
      });
    }
  }, [FetchPurchasingAssetData.data, FetchPurchasingAssetData?.status]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const items = [
    {
      statusid: "08dab011-a6cf-4069-887e-83e5f3473108",
      label: "Awaiting Delivery",
    },
    {
      statusid: "08dab011-a6cf-4069-887e-83e5f3473109",
      label: "Partial Delivered",
    },
    {
      statusid: "08dab011-a6cf-4069-887e-83e5f3473110",
      label: "Delivered",
    },
  ];

  const columns = [
    {
      // title: "PO ID",
      title: t("PO ID"),
      dataIndex: "purchasingOrdercode",
      key: "assetPurchasingOrderid", // Use a unique identifier from your data
      width: "15%",
      render: (purchasingOrdercode, record) => {
        const isHovered = hoveredRowKey === record.assetPurchasingOrderid;
        console.log("asc45rec", record);
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "15px",
            }}
            onMouseEnter={() => setHoveredRowKey(record.assetPurchasingOrderid)}
            onMouseLeave={() => setHoveredRowKey(null)}
          >
            <Link
              to={{
                pathname: `/view-purchasing-order-assets`,
                state: {
                  from: "Asset_Purchasing_Screen",
                  history_AssetName: record.assetname,
                  history_AssetID: record.assetid,
                  history_SupplierName: record.suppliername,
                  history_SupplierID: record.supplierid,
                  history_PurchasingOrderID: record.assetPurchasingOrderid,
                },
              }}
              className={styles.redirect_link}
            >
              {purchasingOrdercode}
            </Link>
            {isHovered && (
              <img className="pdf-img d-none" src={pdfIcon} alt="pdf" />
            )}
          </div>
        );
      },
    },
    {
      // title: "Item Name",
      title: t("Item Name"),
      dataIndex: "assetname",
      key: "assetname",
      width: "30%",
      // responsive: ["md"],
    },
    {
      // title: "Qty",
      title: t("Qty"),
      dataIndex: "quantity",
      key: "quantity",
      width: "10%",
      // responsive: ["md"],
      render: (_, record) => <>{record?.purchasingordersdata[0]?.quantity}</>,
    },
    {
      // title: "Cost",
      title: t("Cost"),
      dataIndex: "costprice",
      key: "costprice",
      width: "10%",
      // responsive: ["md"],
      render: (_, record) => <>{record?.total}</>,
    },

    {
      // title: "Supplier",
      title: t("Supplier"),
      dataIndex: "suppliername",
      key: "suppliername",
      width: "10%",
      // responsive: ["md"],
    },
    {
      // title: "Date",
      title: t("Date"),
      dataIndex: "date",
      key: "date",
      width: "15%",
      // responsive: ["md"],
      render: (_, record) => (
        <>{record.purchasingordersdata[0]?.date?.split("T")[0]}</>
      ),
    },
    // {
    //   title: "In Stock",
    //   dataIndex: "total",
    //   key: "total",
    //   width: "10%",
    //   responsive: ["md"],
    // },
    {
      // title: "Status",
      title: t("Status"),
      dataIndex: "statusname",
      key: "statusname",
      width: "20%",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            overlay={
              <Menu
                onClick={({ key }) =>
                  handleStatusUpdate(record.assetPurchasingOrderid, key)
                }
              >
                {items.map((item) => (
                  <Menu.Item key={item.statusid}>{item.label}</Menu.Item>
                ))}
              </Menu>
            }
          >
            <span className="px-2 w-100 d-flex">
              <span style={{ width: "120px", display: "block" }}>
                {record.statusname}
              </span>
              <DownOutlined className="" />
            </span>
          </Dropdown>
        </Space>
      ),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <img
          src={delete1}
          alt="menu icon"
          className="cursor-pointer"
          onClick={() => deleteItem(record.assetPurchasingOrderid)}
        />
      ),
    },
  ];
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });
  const calculatePagination = (pageNumber) => {
    let records = tableData || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(9 * pageNumber - 8, 1),
      endRecordIndex: Math.min(9 * pageNumber, records.length),
      totalPages: Math.ceil(records.length / 9),
      records: records?.slice((pageNumber - 1) * 9, pageNumber * 9),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };

  useEffect(() => {
    calculatePagination(1);
  }, [tableData]);

  return (
    <div>
      <Row>
        <Col md={6}>
          <p className="addTask d-flex justify-content-start align-items-center">
            <Link
              to={{
                pathname: `/view-purchasing-order-assets`,
                state: {
                  assetName: assetsData?.assetName ?? "",
                },
              }}
              className="redirect-link addTask d-flex justify-content-start align-items-center"
            >
              <img className="me-2 taskImg" src={AddButton} alt=""></img>
              <span>
                {/* Add PO */}
                {t("Add PO")}
              </span>
            </Link>
          </p>
        </Col>

        <Col md={6} className="d-flex justify-content-end align-items-center">
          {/* Pagination comes here */}
          <div className="stock-custom-pagination mobile-width">
            <div>
              {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex}  of  ${paginationObj.totalRecords}`}
            </div>
            <div className="pagination-buttons">
              <div
                className={`update-stock-pagination-button ${
                  paginationObj.currentPage === 1 ? "disabled" : ""
                }`}
                onClick={() =>
                  calculatePagination(paginationObj.currentPage - 1)
                }
              >
                <BsChevronLeft />
              </div>
              <div className="pagination-current-page">
                {paginationObj.currentPage}
              </div>
              <div
                className={`update-stock-pagination-button ${
                  paginationObj.totalPages === 0 ||
                  paginationObj.totalPages === paginationObj.currentPage
                    ? "disabled"
                    : ""
                }`}
                onClick={() =>
                  calculatePagination(paginationObj.currentPage + 1)
                }
              >
                <BsChevronRight />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <div>
            <Table
              dataSource={paginationObj?.records}
              columns={columns}
              pagination={false}
              rowClassName={() => "tableRowRoundedBorder"}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default Purchasing;
